import { Link, useParams } from "react-router-dom";

import { makeKey, projectsByName } from "../data/getData.js";
import { CHAIN_DATA, LINKS, WEBSITE, DAPP } from "../data/metaData.js";
import { ICONS } from "../data/constants.js";

import VerifiedIcon from "./VerifiedIcon.js";

const Detail = () => {
	const { chain: selectedChain, id: projectKey } = useParams();
	const project = projectsByName[projectKey];

	return (
		<div className="section-main section-project">
			<div className="container grid-lg">
				<div className="columns">
					<div className="hero-container column col-md-12">
						<div className="awesome-breadcrumb">
							<ol className="breadcrumb">
								<li className="breadcrumb-item">
									<Link to={`/${selectedChain}`}>
										<span>Home</span>
									</Link>
									<meta itemProp="position" content="1" />
								</li>
								<li className="breadcrumb-item">
									<Link to={`/${selectedChain}/projects`}>
										<span>Projects</span>
									</Link>
									<meta itemProp="position" content="2" />
								</li>
								<li className="breadcrumb-item">
									<Link to={`/${selectedChain}/detail/${projectKey}`}>
										<span>{project.name}</span>
									</Link>
									<meta itemProp="position" content="3" />
								</li>
							</ol>
						</div>
						<div className="awesome-hero">
							<div className="hero-img">
								<img src={project.image} alt={project.name} loading="lazy" />
							</div>
							<div className="hero-content">
								<div className="hero-series">
									{(project.chains || []).map(
										chain => (
											<small
												className="tooltip label-series near"
												data-tooltip={CHAIN_DATA[chain].name}
												key={chain}
											>
												{CHAIN_DATA[chain].name}
											</small>
										)
									)}
								</div>
								<h1 className="hero-title">
									<span>{project.name}</span>
									{project.isVerified && <VerifiedIcon />}
								</h1>
								<h2 className="hero-subtitle">{project.description}</h2>
								<div className="hero-tags">
									{project.tags.map((tag) => (
										<Link key={tag} className="tag-item awesome-tag" to={`/${selectedChain}/projects/${makeKey(tag)}`}>{tag}</Link>
									))}
								</div>
							</div>
							<div className="hero-actions">
								<h2 className="text-assistive">{`${project.name} official and social links`}</h2>
								<div className="hero-links">
									<div className="btn-group">
										{
											project.links[WEBSITE]
												? <a href={project.links[WEBSITE]} target="_blank" rel="noopener noreferrer" className="link-item btn btn-lg btn-primary">
													<img className="icon" style={{filter: 'brightness(0) invert(1)'}} height="20" width="20" src={ICONS[WEBSITE]} alt="website" />
													<span className="text-assistive">{`${project.name} Web`}</span>
													<span>Website</span>
												</a>
												: null
										}
										{
											project.links[DAPP]
												? <a href={project.links[DAPP]} target="_blank" rel="noopener noreferrer" className="link-item btn btn-lg btn-primary">
													<span className="text-assistive">{`${project.name} DApp`}</span>
													<span>Launch DApp</span>
												</a>
												: null
										}
									</div>
								</div>
								<div className="hero-links">
									{LINKS.map((link, index) => (
										index === 0 || !(project.links || {})[link]
											? null
											: <a key={link} href={project.links[link]} target="_blank" rel="noopener noreferrer" className="link-item btn btn-lg btn-link" title={link}>
												<img className="icon" height="20" width="20" src={ICONS[link]} alt={link} />
												<h3 className="text-assistive">{`${project.name} ${link}`}</h3>
											</a>
											
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="columns">
					<div className="column">
						<div className="near-content">
							<div className="content-widget markdown">
								<h2 className="content-title">{`About ${project.name}`}</h2>
								<h3 className="text-assistive">{`What is ${project.name}? What is ? Where can I get ${project.name}  tokens? Who invested ${project.name}? How does ${project.name} compare to other projects?`}</h3>
								{
									project.paragraphs && project.paragraphs.length
										? project.paragraphs.map((paragraph, index) => (<p key={index} >{paragraph}</p>))
										: project.description
								}
							</div>
						</div>
						{/* <div className="near-content">
						<div className="content-widget article-widget">
							<h2 className="content-title">{`${project.name} News`}</h2>
							<h3 className="text-assistive">{`${project.name} funding, strategic partnership news, tutorials articles`}</h3>
							<div className="articles-container">
							<a className="article-item" target="_blank" href="/articles/near-web-wallet-security-update">
								<img className="article-image" src="https://awesome-near.s3.amazonaws.com/near-web-wallet-security-update.jpg" alt=''/>
								<div className="article-detail">
								<div className="article-title">NEAR Web Wallet Security Update</div>
								<div className="article-info">August 3, 2022</div>
								</div>
							</a>
							</div>
						</div>
						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Detail;
